import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Marker } from 'react-google-maps'
import { onCloseMarkerInfo, setMarkerParams } from 'reducers/seaLice/reducer'
import defaultMarker from 'assets/img/mysites-marker.svg'
import defaultRedMarker from 'assets/img/mysites-red-marker.svg'
import othersMarker from 'assets/img/othersites-marker.svg'
import othersRedMarker from 'assets/img/othersites-red-marker.svg'
import defaultMarkerSelected from 'assets/img/mysites-marker-select.svg'
import defaultRedMarkerSelected from 'assets/img/mysites-red-marker-select.svg'
import othersMarkerSelected from 'assets/img/othersites-marker-selected.svg'
import othersRedMarkerSelected from 'assets/img/othersites-red-marker-selected.svg'

class AllSitesMarkerList extends Component {
  componentWillUnmount() {
    this.props.onCloseMarkerInfo()
  }

  onMarkerClick = (mapObj, marker) => {
    this.props.setMarkerParams({
      position: mapObj,
      marker,
    })
  }

  getMarkerIcon = (site, siteData, activeMarker) => {
    const site_id = activeMarker.hasOwnProperty('marker')
      ? activeMarker.marker.site_id
      : null
    const { licenseeId } = this.props

    if (site.licensee_id === licenseeId) {
      // eslint-disable-next-line no-nested-ternary
      return siteData >= 3
        ? site.site_id === site_id
          ? defaultRedMarkerSelected
          : defaultRedMarker
        : site.site_id === site_id
        ? defaultMarkerSelected
        : defaultMarker
    }

    // eslint-disable-next-line no-nested-ternary
    return siteData >= 3
      ? site.site_id === site_id
        ? othersRedMarkerSelected
        : othersRedMarker
      : site.site_id === site_id
      ? othersMarkerSelected
      : othersMarker
  }

  render() {
    const { activeType, licenseeId } = this.props
    const activeMarker = this.props.activeMarker.toJS()
    const sitesData = this.props.sitesData.toArray()

    if (sitesData.length === 0) {
      return null
    }

    return (
      <>
        {sitesData.map(site => {
          const typeValue = site.weeks[5][activeType]

          if (site.location) {
            return (
              <Marker
                key={site.site_id}
                title={site.site_name}
                onClick={mapObj => this.onMarkerClick(mapObj, site)}
                position={{
                  lat: site.location.latitude,
                  lng: site.location.longitude,
                }}
                label={{
                  text: typeValue ? `${typeValue}` : 'N/A',
                  fontSize: '11px',
                  color: licenseeId !== site.licensee_id ? 'white' : 'black',
                }}
                icon={{
                  url: this.getMarkerIcon(
                    site,
                    Number(typeValue),
                    activeMarker,
                  ),
                  scaledSize: new window.google.maps.Size(42, 50),
                }}
              />
            )
          }

          return null
        })}
      </>
    )
  }
}

export default connect(
  state => ({
    sitesData: state.getIn(['seaLice', 'sitesData']),
    licenseeId: state.getIn(['profile', 'licenseeId']),
    activeType: state.getIn(['seaLice', 'activeType']),
    activeMarker: state.getIn(['seaLice', 'markerParams']),
  }),
  {
    setMarkerParams,
    onCloseMarkerInfo,
  },
)(AllSitesMarkerList)
